import styled from "styled-components";
import { getFontSize } from "utils/text-styles";

export const Paragraph = styled.p<{ color?: string, bold?: string }>`
  color: ${(props) => props.color || props.theme.theme.TEXT.PRIMARY} !important;
  transition: font-size 0.15s ease-in-out;
  font-size: ${(props) => getFontSize(props.theme.fontSize, "text")} !important;
  line-height: 1.5;
  font-weight: ${(props) => (props.bold === 'true' ? "bold" : "normal")};
  display: inline-block;
`;

export const Title = styled.h6`
  color: ${(props) => props.theme.theme.TEXT.TITLE};
  transition: font-size 0.15s ease-in-out;
  font-size: ${(props) =>
    getFontSize(props.theme.fontSize, "title")} !important;
  line-height: 3.6rem;
`;

export const Subtitle = styled.h4`
  color: ${(props) => props.theme.theme.TEXT.SECONDARY} !important;
  transition: font-size 0.15s ease-in-out;
  font-size: ${(props) =>
    getFontSize(props.theme.fontSize, "subtitle")} !important;
  line-height: 2.8rem;
`;

export const Anchor = styled.a`
  color: ${(props) => props.theme.theme.TEXT.PRIMARY} !important;
  transition: font-size 0.15s ease-in-out;
  font-size: ${(props) => getFontSize(props.theme.fontSize, "text")} !important;
  line-height: 2.4rem;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.theme.COLOR_ACCENT} !important;
  }
`;

export const Label = styled.label`
  color: ${(props) => props.theme.theme.TEXT.PRIMARY} !important;
  transition: font-size 0.15s ease-in-out;
  font-size: ${(props) => getFontSize(props.theme.fontSize, "text")} !important;
`;
